import { createElementIdSlice } from '../utils/action/createElementSlice';
export const StackContainerState = createElementIdSlice({
    elementName: 'stack-container',
    initialState: {},
    reducers: {
        notifyReorderItems: (state, _action) => state,
    },
});
